import {ProcedureAccessLevel} from 'procedures/design/validation/determineProcedureAccessLevel';

export function isHandleConnectable(
  isProcedureReadOnly: boolean,
  accessLevel: ProcedureAccessLevel | null
): boolean {
  return !isProcedureReadOnly && accessLevel === ProcedureAccessLevel.FULL_ACCESS;
}
